// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-order-button {
  margin: 12px;
}

ion-button {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;AACD;;AACA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAED","sourcesContent":[".add-to-order-button {\n\tmargin: 12px;\n}\nion-button {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 135%;\n\tletter-spacing: 0.01em;\n\ttext-align: center;\n\tcolor: var(--color-white);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
